import {SliderWithUnit} from './SliderWithUnit';
import {withMeta, withSystem} from '@packages/systems/wfdl';
import {TNumber} from '@packages/systems/wfdl-ast';

const value = {min: 0, max: 20, step: 1} as const;

export const Slider = SliderWithUnit({
  min: value.min,
  max: value.max,
  step: value.step,
  inputType: withSystem(
    {label: 'Slider', labelVariant: 'hidden'},
    withMeta({value}, TNumber)
  ),
});
